import styled from 'styled-components'

export const Bar = styled.div`
  display: none;

  @media screen and (max-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9998;
    padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
    background: #001d07;
    border-top: 2px solid #a1ff71;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.3);
    transform: translateY(${({ $show }) => ($show ? '0' : '110%')});
    transition: transform 0.3s ease;
  }
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  line-height: 1.25;
`

export const Title = styled.span`
  color: #fff;
  font-size: 16px;
  font-weight: 900;
`

export const Sub = styled.span`
  color: #a1ff71;
  font-size: 13px;
  font-weight: 600;
`

export const CtaButton = styled.button`
  flex-shrink: 0;
  background: #00a70a;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.5px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(0, 167, 10, 0.35);

  &:active {
    background: #30d51d;
  }
`
